const kategorieRoleSelect = [
    {
        labelcz: 'ME_POZADAVKY_IDIC_OBECNY_SUBJ',
        value: 'M'
    },
    {
        labelcz: 'EMITENT',
        value: 'E'
    },
    {
        labelcz: 'ADMINISTRATOR_EMISE',
        value: 'A'
    },
    {
        labelcz: 'SPRAVCE_EMISE',
        value: 'S'
    }
];

export default kategorieRoleSelect;
